module.exports = __webpack_public_path__ + "static/media/deleteIcon.eac3447f.svg";